module.exports = __webpack_public_path__ + "static/media/fossils.87dde84b.png";